import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

export const usePresenter = () => {
  const { dispatch, appStore, fenceStore } = useStoreon<IState, IEvents>('appStore', 'fenceStore');

  const setTotalPrice = (totalPrice: number) => {
    dispatch('fence/set-total-price', { totalPrice });
  };

  return {
    priceList:  appStore.priceList,
    totalPrice:  fenceStore.totalPrice,
    setTotalPrice,
  };
};
